// =============================================
// SUNNY SHELL SHOPIFY THEME — theme.js
// =============================================

document.addEventListener('DOMContentLoaded', () => {

  // =============================================
  // Mobile Nav Toggle + Close Button
  // =============================================
  const mobileToggle = document.querySelector('.mobile-toggle');
  const mobileDrawer = document.getElementById('mobileNavDrawer');
  const drawerClose  = document.getElementById('drawerClose');

  const openDrawer  = () => { mobileDrawer.classList.add('open'); document.body.style.overflow = 'hidden'; mobileToggle.setAttribute('aria-expanded', 'true'); };
  const closeDrawer = () => { mobileDrawer.classList.remove('open'); document.body.style.overflow = ''; mobileToggle.setAttribute('aria-expanded', 'false'); };

  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', openDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    mobileDrawer.querySelectorAll('a').forEach(link => link.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  }

  // =============================================
  // Catalogue Dropdown — keyboard accessible
  // =============================================
  document.querySelectorAll('.nav-dropdown-trigger').forEach(trigger => {
    trigger.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const dropdown = trigger.closest('.nav-dropdown');
        dropdown.classList.toggle('open');
      }
    });
  });

  // =============================================
  // Product Page — Image Gallery
  // =============================================
  const thumbs    = document.querySelectorAll('.product-thumb');
  const mainImage = document.querySelector('.product-main-image img');

  if (thumbs.length && mainImage) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const newSrc = thumb.querySelector('img')?.src;
        if (newSrc) {
          mainImage.style.opacity = '0';
          mainImage.style.transition = 'opacity 0.2s ease';
          setTimeout(() => { mainImage.src = newSrc; mainImage.style.opacity = '1'; }, 200);
        }
      });
    });
  }

  // =============================================
  // Scroll Fade-In
  // =============================================
  const fadeEls = document.querySelectorAll('.product-card, .feature-card, .catalogue-card, .fade-in-up');
  if (fadeEls.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }, i * 60);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeEls.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });
  }

  // =============================================
  // Variant Selector — Update Price
  // =============================================
  const variantSelect = document.querySelector('.variant-select');
  const priceEl       = document.querySelector('.product-price');

  if (variantSelect && priceEl) {
    variantSelect.addEventListener('change', () => {
      const selected = variantSelect.options[variantSelect.selectedIndex];
      if (selected.dataset.price) priceEl.textContent = selected.dataset.price;
    });
  }


  // =============================================
  // Sort Select — redirect on change
  // =============================================
  const sortSelect = document.getElementById('sortSelect');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      window.location = sortSelect.value;
    });
  }

  // =============================================
  // Collection Filter Buttons
  // =============================================
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

});
